module.exports = __webpack_public_path__ + "img/thumb_24.dfcd8b7d.jpg";